import { IFilter } from "@/models/tables";
import { FilterOperators, FilterTypes } from "@/data/table";
import { ProvisionRequestStatusCodes as PRSC } from "@/data/enums/contractProducts";
import i18n from "@/i18n";

const contractProductRequestsFilters: IFilter[] = [
  {
    key: "function_name",
    label: i18n.t("_.function_name"),
    type: FilterTypes.STRING,
    operator: FilterOperators.CONTAINS,
    group: "request"
  },
  {
    key: "is_setup",
    label: i18n.t("_.is_setup"),
    type: FilterTypes.SELECT_RADIO,
    operator: FilterOperators.EQUAL,
    value: "true",
    group: "request"
  },
  {
    key: "status.code",
    label: i18n.t("_.status"),
    type: FilterTypes.SELECT_CHECKBOX,
    options: [
      {
        value: PRSC.PROVISION_REQUEST_DRAFT,
        label: i18n.t("_.draft").toString()
      },
      {
        value: PRSC.PROVISION_REQUEST_SCHEDULED,
        label: i18n.t("_.scheduled").toString()
      },
      {
        value: PRSC.PROVISION_REQUEST_PENDING,
        label: i18n.t("_.pending").toString()
      },
      {
        value: PRSC.PROVISION_REQUEST_DISPATCHED,
        label: i18n.t("_.dispatched").toString()
      },
      {
        value: PRSC.PROVISION_REQUEST_SUCCESS,
        label: i18n.t("_.success").toString()
      },
      {
        value: PRSC.PROVISION_REQUEST_ERROR,
        label: i18n.t("_.error").toString()
      },
      {
        value: PRSC.PROVISION_REQUEST_CANCELLED,
        label: i18n.t("_.cancelled").toString()
      }
    ],
    value: [],
    operator: FilterOperators.EQUAL,
    group: "request"
  },
  {
    key: "unresolved",
    label: i18n.t("_.is_unresolved"),
    value: "1",
    type: FilterTypes.SELECT_RADIO,
    operator: FilterOperators.EQUAL
  },
  {
    key: "created_at",
    label: i18n.t("_.date_created"),
    type: FilterTypes.DATE,
    operator: FilterOperators.AFTER,
    group: "request"
  },
  {
    key: "dispatched_at",
    label: i18n.t("_.date_dispatched"),
    type: FilterTypes.DATE,
    operator: FilterOperators.AFTER,
    group: "request"
  },
  {
    key: "scheduled_for",
    label: i18n.t("_.date_scheduled"),
    type: FilterTypes.DATE,
    operator: FilterOperators.AFTER,
    group: "request"
  },
  {
    key: "updated_at",
    label: i18n.t("_.date_updated"),
    type: FilterTypes.DATE,
    operator: FilterOperators.AFTER,
    group: "request"
  }
];

export default contractProductRequestsFilters;
